import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Document_signature_request } from '../models/document_signature_request';

import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class DocumentSignatureRequestService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Document_signature_request> {
    return this.getWithRest("id/" + id);
  }

  private getWithRest(rest_url: string) : Promise<Document_signature_request> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'document_signature_request_controller/' + rest_url).subscribe((response:any) => {
      if(response.type == 'document_signature_request' && response.data){
        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
}

	updateSignature(dsr: Document_signature_request): Promise<any> {
    let put_data = {
        data: {
          type: 'document_signature_request',
          attributes: dsr
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'document_signature_requests',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='document_signature_response') {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
  }

}
